import {Entity} from "./entity";
import {deserialize} from "cerialize";

export class Logo {
  @deserialize
  url: string = null;
}
